var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C0E9BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.9H11.9C10.85 23.9 10 23.05 10 22V12.9C10 11.85 10.85 11 11.9 11H27.1C28.15 11 29 11.85 29 12.9V18",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.179 15.9709C22.106 16.8979 22.106 18.4019 21.179 19.3299C20.252 20.2569 18.748 20.2569 17.82 19.3299C16.893 18.4029 16.893 16.8989 17.82 15.9709C18.748 15.0429 20.252 15.0429 21.179 15.9709",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.8001V22.0001C30 21.2261 28.432 20.6001 26.5 20.6001C24.568 20.6001 23.001 21.2271 23 22.0001V27.6001C23.001 28.3731 24.567 29.0001 26.5 29.0001C28.433 29.0001 29.999 28.3731 30 27.6001V22.0001",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 22C23.001 22.773 24.568 23.4 26.501 23.4C28.434 23.4 30 22.773 30 22",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 24.7998C23.001 25.5728 24.568 26.1998 26.501 26.1998C28.434 26.1998 30.001 25.5728 30.001 24.7998",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H13",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H25",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/PriceIcon.eafcd5eccb4fc5345e6ae04c436f35a0.svg";
export { ForwardRef as ReactComponent };